import Axios, { AxiosResponse } from 'axios';
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Policy from './Policy';

export class PolicyServiceStatic {
    getPolicy(): Promise<AxiosResponse<Policy>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/policy`
        return AxiosPostProcessor.postProcess(Axios.get<Policy>(url, AxiosDefaultRequestConfig.merge({ })));
    }
}

const PolicyService = new PolicyServiceStatic();
export default PolicyService;
